export default "__VITE_ASSET__SofSvkjN__"